import { Button } from '@vrplatform/components';
import { useQuery, useTeam } from '@vrplatform/data';
import { RefreshCwIcon } from '@vrplatform/icons';
import { whereConnectionStatusDefault } from '@vrplatform/ui-common';
import { useMemo } from 'react';
import { HiddenFeatureIndicator } from '../../../components';
import { useExtractModal } from '../../../modals';
import type { ConnectionExtractor } from '../../../modals/extract-single-modal/useExtractSingleButtonQuery';

export const FetchListingsButton = () => {
  const { open } = useExtractModal();
  const { listingSchema, pms, loading } = usePms();

  const openExtractModal = () => {
    if (!pms?.length || !listingSchema) return;

    open({
      connectionIds: pms.map((x) => x.id),
      extractType: listingSchema.name,
    });
  };

  return (
    <HiddenFeatureIndicator permission="partner-admin">
      <Button
        loading={loading}
        leftIcon={RefreshCwIcon}
        variant="primary"
        onClick={openExtractModal}
      >
        Update from{' '}
        {!pms?.length ? '...' : pms.length > 1 ? 'PMS' : pms[0].app.name}
      </Button>
    </HiddenFeatureIndicator>
  );
};

function usePms() {
  const [{ id: teamId }] = useTeam();

  const {
    data: pms,
    isLoading: loading,
    refetch,
  } = useQuery(
    (q, args) => {
      return q
        .connection({
          where: {
            status: whereConnectionStatusDefault,
            tenantId: {
              _eq: args.teamId,
            },
            app: {
              category: {
                _eq: 'propertyManagementSystem',
              },
            },
          },
          order_by: [{ appId: 'asc_nulls_last' }],
          distinct_on: ['appId'],
        })
        .map((connection) => ({
          id: connection.id,
          app: {
            id: connection.app?.id,
            name: connection.app?.name,
            useV3:
              (connection.app?.version || 0) > 0 ||
              (connection.version || 0) > 0,
            extractors: (connection.app.info({
              path: 'extractors',
            }) || []) as ConnectionExtractor[],
          },
        }));
    },
    {
      skip: !teamId,
      variables: {
        teamId,
      },
    }
  );

  const listingSchema = useMemo(() => {
    const extractors = pms?.flatMap((x) => x.app.extractors);

    if (!extractors?.length) return undefined;

    return extractors.find((extractor) => extractor.name === 'listing');
  }, [pms]);

  return {
    listingSchema,
    pms,
    loading,
    refetch,
  };
}
